import Card from "@rio-cloud/rio-uikit/Card";
import { ReactNode } from "react";
import { resolveKpiDelta } from "@utils/kpiDelta";

export const KPI_ICON_WRAPPER_STYLE = { width: 56, height: 50, borderRadius: 6 } as const;
export const KPI_ICON_STYLE = { fontWeight: 400 } as const;
export const KPI_VALUE_STYLE = { fontWeight: 400, fontSize: 24 } as const;
export const KPI_FOOTER_STYLE = { fontSize: 15 } as const;

interface KpiCardIconProps {
  symbol?: string;
}

export const KpiCardIcon = ({ symbol = "R$" }: Readonly<KpiCardIconProps>) => (
  <span className="text-size-h2 text-medium text-color-primary" style={KPI_ICON_STYLE}>
    {symbol}
  </span>
);

interface KpiCardDeltaProps {
  deltaPercentage?: number | null;
  vsLabel: string;
  roundPercentage?: boolean;
}

export const KpiCardDelta = ({ deltaPercentage, vsLabel, roundPercentage }: Readonly<KpiCardDeltaProps>) => {
  const delta = resolveKpiDelta(deltaPercentage);
  const percentage = Math.abs(delta.value);

  return (
    <>
      <span className={`display-flex align-items-center gap-2 text-medium ${delta.colorClass}`}>
        <span className={`rioglyph ${delta.iconClass}`} />
        {roundPercentage ? percentage.toFixed(0) : percentage}%
      </span>
      <span className="margin-left-5 text-color-gray">{vsLabel}</span>
    </>
  );
};

interface KpiCardProps {
  label: ReactNode;
  value: ReactNode;
  icon: ReactNode;
  footer: ReactNode;
  contentGapClassName: string;
  footerGapClassName?: string;
}

const KpiCard = ({ label, value, icon, footer, contentGapClassName, footerGapClassName }: Readonly<KpiCardProps>) => {
  const footerClassName = [
    "display-flex flex-wrap align-items-center",
    footerGapClassName,
    "bg-lightest padding-y-10 padding-x-20",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Card padding={0} className="overflow-hidden display-flex flex-column height-100pct">
      <div className="padding-15 flex-1-1">
        <div className={`display-flex align-items-center ${contentGapClassName}`}>
          <div
            className="display-flex align-items-center justify-content-center flex-0 bg-lightest"
            style={KPI_ICON_WRAPPER_STYLE}
          >
            {icon}
          </div>
          <div className="display-flex flex-column gap-2 min-width-0">
            <span className="text-size-18 text-color-gray">{label}</span>
            <span style={KPI_VALUE_STYLE}>{value}</span>
          </div>
        </div>
      </div>
      <div className={footerClassName} style={KPI_FOOTER_STYLE}>
        {footer}
      </div>
    </Card>
  );
};

export default KpiCard;
